import CryptoJS from 'crypto-js';

/**
 * Build a URL for a private uploaded file (tax documents, transaction proofs)
 * that are now served through the API's authenticated file route (API-A5).
 *
 * These files are opened via plain <a href> / <img src>, which cannot send the
 * accesstoken header, so the token is appended as a query parameter. The API
 * verifies the session and that the caller owns the file before serving it.
 *
 * @param {string} filePath  e.g. "public/uploads/tax_documents/"
 * @param {string} fileName  e.g. "abc.pdf"
 * @returns {string} full URL including the access token
 */
export const buildSecureFileUrl = (filePath, fileName) => {
    const base = `${process.env.REACT_APP_API_URL}${filePath}${fileName}`;
    let token = '';
    try {
        const bytes = CryptoJS.AES.decrypt(
            localStorage.getItem('authUser'),
            process.env.REACT_APP_USER_TOKEN_SECRET
        );
        const auth = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        token = auth && auth.accesstoken ? auth.accesstoken : '';
    } catch (e) {
        token = '';
    }
    if (!token) return base;
    const sep = base.includes('?') ? '&' : '?';
    return `${base}${sep}token=${encodeURIComponent(token)}`;
};

export default buildSecureFileUrl;
